import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './components/guardarToken/authContext';

// Uso: <ProtectedRoute><ComponentePrivado /></ProtectedRoute>
export default function ProtectedRoute({ children }) {
    const { authToken, isValidating } = useAuth();

    if (isValidating) {
        return <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white text-xl">Verificando sesión...</div>;
    }

    if (!authToken) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
